export default __webpack_public_path__ + "static/media/ColorCars_03.360ab83f.png";